// extracted by mini-css-extract-plugin
module.exports = {"ShowAllText":"style_ShowAllText__3Vdn6"};